import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import React from 'react';
import jsurl from 'jsurl';

interface Props {
  deal: Deal;
}

export const LendingSupportCloudWatchLinks: React.FC<Props> = React.memo(
  ({ deal }) => {
    const generateCloudWatchLink = (
      additionalFilters: string[] = [],
    ): string => {
      const editorString = [
        'fields @timestamp, level, module, message, @message, @logStream, @log',
        `| filter @message like '${deal.id}'`,
        ...additionalFilters,
        '| limit 10000',
        '| sort @timestamp asc',
      ].join('\n');

      const request = {
        end: 0,
        // 7 days
        start: -604800,
        timeType: 'RELATIVE',
        unit: 'seconds',
        editorString,
        source: ['BackendLogGroup'],
      };

      const region = 'us-east-1';
      const encoded = jsurl.stringify(request);
      return `https://${region}.console.aws.amazon.com/cloudwatch/home?region=${region}#logsV2:logs-insights$3FqueryDetail$3D${encoded}`;
    };

    return (
      <>
        <div>CloudWatch Links</div>
        <a href={generateCloudWatchLink()} target="_blank" rel="noreferrer">
          All Deal Logs
        </a>
        <div />
        <a
          href={generateCloudWatchLink(['| filter module like "upstart"'])}
          target="_blank"
          rel="noreferrer"
        >
          All Upstart Lending Logs
        </a>
      </>
    );
  },
);
